import { apiClient, setHeaderToken } from "@/api/api.ts"
import { AuthStore } from "@/store/useAuthStore.ts"

export const fetchNewToken = async (): Promise<string | null> => {
  try
  {
    // @ts-ignore
    return await apiClient.get( "/refresh", { skipAuthRefresh: true } ).then( ( res ) => res.data.accessToken )
  } catch ( error )
  {
    console.log( error )

    return null
  }
}

export const refreshAuthLogic = async ( failedRequest: any ) => {
  const newToken = await fetchNewToken()

  if ( newToken )
  {
    apiClient.defaults.headers.common.authorization = "Bearer " + newToken
    failedRequest.response.config.headers.Authorization = "Bearer " + newToken
    setHeaderToken( newToken )

    return Promise.resolve( newToken )
  } else
  {
    AuthStore.getState().logOut();
    if (window.location.pathname !== "/login") {
        window.location.href = "/login";
    }

    return Promise.reject()
  }
}
